module.exports = __webpack_public_path__ + "static/media/ryan.bac7ae9b.jpg";